import { Table } from 'antd'
import { useEffect, useState } from 'react'
import styles from './index.module.less'
import { isString } from 'antd/es/button'
export default function ConfigPriceList(props: any) {
  const { data } = props
  const [tbData, setTbData] = useState<any>([])
  const NumberMap = {
    standardNumber: '标配数量',
    additionalNumber: '增项数量',
    additionalPrice: '增项金额(元)',
  }
  useEffect(() => {
    if (data) {
      handleData(data)
    }
  }, [data])
  const handleData = data => {
    data.forEach((tb, tbIndex) => {
      let column = [
        { title: '统计数据 | 通项', dataIndex: 'feeItem', key: 'feeItem', width: 200 },
        ...tb.budgetMaterialResponseList.map(item => ({
          title: item.name,
          dataIndex: item.name,
          key: item.name,
          width: 200,
          render: (text, record, index) => {
            // 判断分子分母大小
            let standardDenominator = 0 // 分母
            let standardNumerator = 0 // 分子
            if (isString(text) && text.includes('/')) {
              let arr = text.split('/')
              standardNumerator = Number(arr[0])
              standardDenominator = Number(arr[1])
            }
            if (standardNumerator < standardDenominator && standardDenominator) {
              return <span style={{ color: 'red' }}>{text}</span>
            } else {
              return <span>{text}</span>
            }
          },
        })),
      ]
      let dataSource = Object.keys(NumberMap).map((key, index) => {
        const row = { key: index.toString(), feeItem: NumberMap[key] }
        tb?.budgetMaterialResponseList?.forEach(item => {
          if (key === 'standardNumber') {
            // 标配数量单独处理
            row[item.name] = item.standardNumerator + '/' + item.standardDenominator
          } else {
            row[item.name] = item[key]
          }
        })
        return row
      })
      tb.column = column
      tb.dataSource = dataSource
    })
    setTbData([...data])
  }
  return (
    <div className={styles.tbContainer}>
      {tbData.map((tb, tbIndex) => {
        return (
          <div>
            <div className={styles.tbHeader}>
              <h4>{tb.spaceName}</h4>
              {tb.spaceParameterName && tb.spaceParameterValueName ? (
                <p>
                  {tb.spaceParameterName}：{tb.spaceParameterValueName}
                </p>
              ) : null}
            </div>
            <Table dataSource={tb.dataSource} columns={tb.column} pagination={false} />
          </div>
        )
      })}
    </div>
  )
}
